import classes from './navigation.module.css'
const Navigation = ({ children }) => {
    return <nav className={`nav-menu ${classes.navigation}`}>{children}</nav>;
};
export default Navigation;
